export default __webpack_public_path__ + "static/media/monbg.1c2e8659.jpg";